/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Success_Verification_SentInputs */



/**
* | output |
* | --- |
* | "Verification email sent! Please check your inbox." |
*
* @param {Login_Success_Verification_SentInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_success_verification_sent = /** @type {((inputs?: Login_Success_Verification_SentInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Success_Verification_SentInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Email de vérification envoyé ! Veuillez vérifier votre boîte de réception.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Bestätigungs-E-Mail wurde versendet! Bitte überprüfen Sie Ihren Posteingang.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Email di verifica inviata! Controlla la tua casella di posta.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Письмо с подтверждением отправлено! Пожалуйста, проверьте свою почту.")
	if (locale === "es") return /** @type {LocalizedString} */ ("¡Correo de verificación enviado! Revisa tu bandeja de entrada.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("验证邮件已发送！请查收您的邮箱。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("確認メールを送信しました。受信トレイをご確認ください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सत्यापन ईमेल भेज दिया गया है! कृपया अपना इनबॉक्स देखें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("E-mail de verificação enviado! Por favor, verifique sua caixa de entrada.")
	return /** @type {LocalizedString} */ ("Verification email sent! Please check your inbox.")
});